<template>
  <div v-rect-loading="loading" class="report-page">
    <div class="head">
      <span class="label">{{ $t(`${i18nPrefix}.label.myReport`) }}</span>
      <span class="icon-group">
        <i v-rect-loading="exportReportTask.loading" class="download-icon iconfont icona-ResumeDownload" @click="handleDownloadReport"></i>
      </span>
    </div>
    <div v-if="showIframe" class="content">
      <iframe class="report-iframe" ref="iframe" :src="$DjangoBaseUrl('/django_rest/personal/profile-pdf/?show_report=1&html=1')" @load="iframeLoad"></iframe>
    </div>
  </div>
</template>

<script>
import { AsyncTask } from '@/utils/common'
import { mapActions } from 'vuex'

export default {
  props: {
    personalInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'personal.report',
      loading: true,
      reportInfo: null,
      taskId: '',
      showIframe: true,
      changingLanguage: false,
      exportReportTask: {
        task: null,
        loading: false
      }
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    this.$eventBus.$on('changingLanguage', (change) => {
      this.changingLanguage = change
    })
  },
  mounted () {
  },
  methods: {
    ...mapActions('personal', ['exportPersonalProfilePDF', 'getExportPersonalProfilePDFTaskStatus']),
    iframeLoad () {
      this.loading = false
    },
    async handleDownloadReport () {
      const exportReportTask = this.exportReportTask
      if (exportReportTask.loading) {
        return
      }
      exportReportTask.loading = true
      exportReportTask.task = new AsyncTask(() => this.exportPersonalProfilePDF({
        show_report: true,
        show_base_info: false
      }), (taskId) => this.getExportPersonalProfilePDFTaskStatus({
        task_id: taskId
      }), (taskId) => {
        window.location.href = this.$DjangoBaseUrl(`/django_rest/personal/export/profile/?task_id=${taskId}&download=1`)
        exportReportTask.task = null
        exportReportTask.loading = false
      })
    }
  },
  watch: {
    changingLanguage: {
      handler () {
        if (!this.changingLanguage) {
          this.showIframe = false
          this.loading = true
          this.$nextTick(() => {
            this.showIframe = true
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.report-page {
  .head {
    position: relative;
    height: 52px;
    padding: 16px 0 16px 40px;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

    .label {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #606266;
    }

    .icon-group {
      position: absolute;
      right: 40px;

      .download-icon {
        font-size: 20px;
        color: #0096cc;
        cursor: pointer;

        ::v-deep {
          .el-loading-spinner {
            margin-top: -12px;

            .loading-spinner {
              .spinner {
                width: 20px;
                height: 20px;

                >div {
                  width: 3px;
                }
              }
            }
          }
        }
      }
    }
  }

  .content {
    background-color: #fff;

    .report-iframe {
      width: 100%;
      height: calc(100vh - 140px);
      height: calc(100dvh - 140px);
      border: none;
    }
  }
}
</style>
